import httpManager from "@/app/shared/utils/httpManager";

export async function downloadTemplateWhatsapp(data) {
  const body = data;
  const url = "/strategies/whatsapp/download-template/";
  const response = await httpManager.post(url, body, { blob: true });
  return response.data;
}
